import { privateFetch } from "api/privateFetch";

/**
 * @typedef {{id: number; cifNumber: number; messageType: string; messageTypeId: number; message: string; createdOn: string; messageSeenStatus: number}} Response
 */

/**
 * Update notification
 * @param {{cifNumber: number; notificationId: number}} Paylaod User ID & Notification ID
 * @returns {Promise<Response[]>} Response
 */
const updateNotification = async ({ cifNumber, notificationId }) => {
  const { data } = await privateFetch.put(
    `/notifications/${cifNumber}?notificationId=${notificationId}`
  );
  return data;
};

export default updateNotification;
